import React from "react";

/**
 * Minimized Design Image Progress
 * Shows in the bottom-right corner when image elements in the book are still
 * generating / not in their final state.
 */
export default function MinimizedDesignImageProgress({
  count = 0,
  onClick = null,
}) {
  if (!count || count <= 0) return null;

  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      onClick={onClick}
      className={[
        "fixed bottom-10 right-6 w-80 bg-white rounded-lg shadow-2xl",
        "border border-gray-200 flex flex-col z-40 overflow-hidden",
        onClick ? "cursor-pointer" : "",
      ].join(" ")}
    >
      <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-purple-50 flex-shrink-0">
        <h3 className="text-sm font-semibold text-gray-900 truncate">
          Designing Images
        </h3>
      </div>

      <div className="px-4 py-2 flex flex-col justify-center flex-shrink-0">
        <p className="text-xs font-medium text-gray-700 text-center">
          {count} Image{count === 1 ? "" : "s"} Generating...
        </p>
        {onClick && (
          <p className="text-[10px] text-indigo-600 text-center mt-1">
            Click to view generating image
          </p>
        )}
      </div>
    </Wrapper>
  );
}
